import _extends from 'babel-runtime/helpers/extends';

import { mapActions, mapState } from 'vuex';

export default {
  name: 'toggle-button',

  computed: _extends({}, mapState({
    isExpand: function isExpand(state) {
      return state.creative.template.workSpaceSetting.rightSideBar_isExpand;
    }
  })),

  methods: _extends({}, mapActions({
    updateWorkSpaceSetting: 'creative/template/updateWorkSpaceSetting'
  }), {
    toggleSideBar: function toggleSideBar() {
      this.updateWorkSpaceSetting({
        rightSideBar_isExpand: !this.isExpand
      });
    }
  })
};